export default __webpack_public_path__ + "static/purple-81ebf95ce53968c39933deebdab61ebd.png";